<script setup lang="ts">
import type { IImpactAllStates } from "~/types/api";
import type { IGeolocalization } from "~/types/components";
import ImpactMap from "./ImpactMap.vue";
import ImpactTop from "./ImpactTop.vue";

interface ImpactDemographicsProps {
  geoLocations: Array<IGeolocalization>;
  countries: Array<Highcharts.PointOptionsObject>;
  referrers: Array<Highcharts.PointOptionsObject>;
  loading: IImpactAllStates;
  error: IImpactAllStates;
}

defineProps<ImpactDemographicsProps>();

const emit = defineEmits([
  "error-geolocations",
  "error-countries",
  "error-referrers"
]);
</script>

<template>
  <div class="ImpactDemographics">
    <ImpactMap
      :items="geoLocations"
      :is-loading="loading.geolocations"
      :has-error="error.geolocations"
      @error="emit('error-geolocations')" />
    <ClientOnly>
      <ul class="ImpactDemographics__top">
        <li class="ImpactDemographics__top__item">
          <h5 class="ImpactDemographics__title">Top countries</h5>
          <ImpactTop
            :items="countries"
            :is-loading="loading.countries"
            :has-error="error.countries"
            @error="emit('error-countries')" />
        </li>
        <li class="ImpactDemographics__top__item">
          <h5 class="ImpactDemographics__title">Top referring sites</h5>
          <ImpactTop
            :items="referrers"
            :is-loading="loading.referrers"
            :has-error="error.referrers"
            @error="emit('error-referrers')" />
        </li>
      </ul>
    </ClientOnly>
  </div>
</template>
<style lang="scss">
.ImpactDemographics {
  &__top {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;

    @media #{$break-sm} {
      grid-template-columns: 1fr;
    }
  }

  &__title {
    @include f-14-500;
    color: $textPrimary;
    margin-bottom: 0;
  }
}
</style>
